import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SnackbarConfig, SubscribingComponent } from "app/common";
import { WorkflowControllerService } from "app/core/workflow/workflow-controller/workflow-controller.service";
import { AnalyticsService } from "app/shared/modules/analytics/services/analytics.service";
import { finalize, takeUntil } from "rxjs";
import { StatementService } from "../statement.service";
import { Statement } from "..";
import { ToolsBarButtonInterface } from "app/shared/components/tools-bar/tools-bar.component";
import { SHOW_SNACKBAR } from "app/reducers/actions/snackbar";
import { Store } from "@ngrx/store";
import { State } from "app/reducers";

@Component({
  selector: "app-payment-checkout",
  templateUrl: "./upsell-page.component.html",
  styleUrls: ["./upsell-page.component.scss"],
  standalone: false
})
export class UpsellPageComponent extends SubscribingComponent implements OnInit {
  private loadingStatementData = true;
  private loading = false;
  private loadingSquareLoader = false;
  private _isInitialized = true;
  public buttons: ToolsBarButtonInterface[] = [];

  public statementId: number;
  public statement: Statement;

  constructor(
    public workFlowController: WorkflowControllerService,
    public analyticsService: AnalyticsService,
    private route: ActivatedRoute,
    private statementService: StatementService,
    private router: Router,
    private store: Store<State>
  ) {
    super();
  }
  ngOnInit() {
    this.route.params.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params) => {
      const statementId = parseInt(params["statementId"], 10);
      this.statementId = statementId;

      this.getStatementData();
    });

    // this.store
    //   .select(getUser)
    //   .pipe(takeUntil(this.ngUnsubscribe))
    //   .subscribe((user: User) => {
    //     if (user) {
    //       this.user_id = user.id;
    //     }
    //   });

    this.setButtons();
  }

  public get isInitialized(): boolean {
    return !this.loadingStatementData && this._isInitialized;
  }

  public get isLoading(): boolean {
    return this.loading || !this.isInitialized;
  }

  public get isLoadingSquareLoader(): boolean {
    return !this.isLoading && this.loadingSquareLoader;
  }

  private setButtons(): void {
    this.buttons = [
      {
        type: "skip",
        label: "Nie, dziękuję",
        action: this.setStandardPackage.bind(this)
      },
      {
        type: "proceed",
        label: "Wybieram PREMIUM",
        action: this.setPremiumPackage.bind(this)
      }
    ];
  }

  public setPremiumPackage(): void {
    this.statement.setPremiumPackage();
    this.updateStatement();
  }

  public setStandardPackage(): void {
    if (this.statement.isPremiumPackage) {
      this.statement.setStandardPackage();
      console.log("setStandardPackage");
      this.updateStatement();
    } else {
      this.workFlowController.goToTheNextStep();
    }

    //
  }

  public updateStatement(): void {
    this.statementService
      .updateStatement(this.statement.id, this.statement.upsellPackageSelectionStepPayload())
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response: Statement) => {
          Object.assign(this.statement, response);
          this.workFlowController.goToTheNextStep();
        },
        error: () => {
          this.loading = false;
          this.store.dispatch({
            type: SHOW_SNACKBAR,
            payload: new SnackbarConfig("COMMON.GLOBAL_ERROR", "ERROR")
          });
        }
      });
  }

  private getStatementData(): void {
    this.loadingStatementData = true;
    this.statementService
      .getStatement(this.statementId)
      .pipe(
        takeUntil(this.ngUnsubscribe),
        finalize(() => {
          this.loadingStatementData = false;
        })
      )
      .subscribe({
        next: (response: Statement) => {
          this.statement = response;
          this.workFlowController.init(this.statement);
          this._isInitialized = true;
        },
        error: () => {
          this.router.navigate(["/new"]);
        }
      });
  }
}
